import React from 'react';
import BaseComponent from 'meta/features/base-component';
// @ts-ignore there are no publicly available types for this library
import { Container as RLContainer } from 'react-layout-components';
import cn from 'classnames';
import './style.less';
class Container extends BaseComponent {
    static defaultProps = {
        visible: true,
        bordered: false
    };
    render() {
        let { style, className, children, visible, bordered, ...restProps } = this.props;
        let _style = Object.assign({}, { position: 'relative' }, style);
        let _class = cn('ui2-container', className, {
            'hidden': !visible,
            'ui2-inner-panel': bordered
        });
        return (<RLContainer {...restProps} className={_class} style={_style}>
                {children}
            </RLContainer>);
    }
}
export default Container;
